import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Toggle } from 'core/hoc';

// Import icons by individual modules for better code splitting
import { default as ShareIcon } from 'core/icons/Share';
import { default as LinkIcon } from 'core/icons/Link';
import Messenger from 'core/icons/Messenger';
import Facebook from 'core/icons/Facebook';
import Twitter from 'core/icons/Twitter';
import Pinterest from 'core/icons/Pinterest';

import {
	ShareBtn,
	Links,
	Link,
	Icon,
	Wrapper,
} from './shareStyles';


class Share extends Component {
	state = {
		copied: false
	}

	triggerCopy = () => {
		this.setState({
			copied: true
		});

		setTimeout(() => {
			this.setState({
				copied: false
			});
		}, 1500);
	}

	render () {
		const { url } = this.props;
		const { copied } = this.state;
		return (
			<Toggle>
				{({ on, toggle, wrapper }) => (
					<Wrapper>
						<ShareBtn onClick={toggle} >
							<ShareIcon />
						</ShareBtn>

						{on && (
							<Links isOn={on} ref={wrapper}>
								<Link href={`fb-messenger://share/?link=${url}`}>
									<Icon>
										<Messenger />
									</Icon>
									Share in Messenger
								</Link>

								<Link href={`http://www.facebook.com/sharer.php?u=${url}`}>
									<Icon>
										<Facebook />
									</Icon>
									Facebook
								</Link>

								<Link href={`https://twitter.com/share?url=${url}`}>
									<Icon>
										<Twitter />
									</Icon>
									Twitter
								</Link>

								<Link href={`https://pinterest.com/pin/create/button/?url=${url}`}>
									<Icon>
										<Pinterest />
									</Icon>
									Pinterest
								</Link>

								<CopyToClipboard text={url} onCopy={this.triggerCopy}>
									<Link as={'button'}>
										<Icon>
											<LinkIcon />
										</Icon>
										{ copied
											? 'Link Copied ✅'
											: 'Copy Link'
										}
									</Link>
								</CopyToClipboard>
							</Links>
						)}
					</Wrapper>
				)}
			</Toggle>
		);
	}
}

Share.propTypes = {
	url: PropTypes.string,
};

export default Share;
